import { Controller } from "@hotwired/stimulus"

// Polls the Deep Context Evaluation status endpoint while a job runs, then
// reloads the page so the server-rendered incident is shown.
export default class extends Controller {
  static values = {
    statusUrl: String,
    status: String,
    intervalMs: { type: Number, default: 2500 },
    maxAttempts: { type: Number, default: 240 }
  }

  connect() {
    this.attempts = 0
    if (this.statusValue === "running" || this.statusValue === "pending") {
      this.timer = setTimeout(() => this.poll(), this.intervalMsValue)
    }
  }

  disconnect() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }

  async poll() {
    if (this.attempts++ >= this.maxAttemptsValue) return
    try {
      const r = await fetch(this.statusUrlValue, {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      })
      if (r.ok) {
        const d = await r.json()
        if (d.status === "complete" || d.status === "error") {
          window.location.reload()
          return
        }
      }
    } catch (e) { /* network blip — keep polling */ }
    this.timer = setTimeout(() => this.poll(), this.intervalMsValue)
  }
}
